import { render, staticRenderFns } from "./CloudWhatsapp.vue?vue&type=template&id=4b84cd14&scoped=true&"
import script from "./CloudWhatsapp.vue?vue&type=script&lang=js&"
export * from "./CloudWhatsapp.vue?vue&type=script&lang=js&"
import style0 from "./CloudWhatsapp.vue?vue&type=style&index=0&id=4b84cd14&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b84cd14",
  null
  
)

export default component.exports